import { z } from 'zod';

export const CreateWorkoutProgressFeedbackCommentDto = z.object({
  // matches the .max(2000) convention used by other free-text fields
  // (note/description) elsewhere in this codebase — "comment" itself has no
  // prior cap to follow.
  comment: z.string().trim().min(1).max(2000),
});

export type ApiCreateWorkoutProgressFeedbackCommentDto = z.infer<
  typeof CreateWorkoutProgressFeedbackCommentDto
>;
